import * as Action from '../action';

export default (state = {}, action) => {
  switch (action.type) {
    case Action.ADD_FEEDER_SERVICE_AREA_LIST:
      return { ...action.areaList };
    default:
      return state;
  }
};
